module.exports = __webpack_public_path__ + "media/components/wind-icon/static/W@2x-dda6db560f4461c4a25eb07dc8867a74.png";